import { createFileRoute } from '@tanstack/react-router'
import RffPaymentsPage from '@/features/meals/rff-payments-page'

export const Route = createFileRoute('/_authenticated/dashboard/meals/rff-payments')({
  component: RffPaymentsPage,
})
